<template>
    <div style="position: relative; height: 1130px; overflow-y: auto;">
        <div
            v-for="(item, index) in vueText"
            :key="index"
            class="text-control"
            :style="index == 0 ? defaultHeigth : 'height: 1460px;'"
        >
            <div style="position: relative; width: 945px; margin: 0px auto;">
                <div v-if="table_type" style="margin-bottom: 10px;">
                    <ckeditor
                        v-model="item[`${item.key}`]"
                        :editor="editor"
                        :config="editorConfig"
                        @selection-change="changeEdiror(item, index)"
                        @input="ShifokorText(item, index)"
                        :style="index == 0 ? defaultHeigth : 'height: 1400px;' + 'width: 950px !important;'"
                    >
                    </ckeditor>
                </div>
                <div v-else>
                    <vue-editor
                        :ref="'vueTextEditor' + index"
                        :id="'text' + index"
                        class="vueTextEditor"
                        :editorToolbar="customToolbar"
                        :disabled="disabled"
                        :style="index == 0 ? defaultHeigth : 'height: 1400px;'"
                        v-model="item[`${item.key}`]"
                        @selection-change="changeEdiror(item, index)"
                        @input="ShifokorText(item, index)"
                    />
                </div>

                <div>
                    <!-- <b-button
                        :class="{ btnArrow: index, btnArrowIndex: !index }"
                        variant="primary"
                        type="number"
                        @click="ArrowClick"
                    >
                        <b-icon
                          style="width: 15px;"
                          icon="arrow90deg-right"
                          aria-hidden="true"
                        ></b-icon>
                    </b-button> -->
                    <b-button
                        v-if="kundalik && !disabled"
                        :class="{textPechat: index, textPechatI: !index}"
                        variant="primary"
                        type="number"
                        @click="textPechat(item)"
                    >
                        <b-icon
                          style="width: 15px;"
                          icon="printer-fill"
                          aria-hidden="true"
                        ></b-icon>
                    </b-button>
                    <b-button
                        v-if="index && !disabled"
                        class="trash-text"
                        variant="outline-danger"
                        type="number"
                        @click="deleteText(index)"
                    >
                        <b-icon
                          style="width: 15px;"
                          icon="trash-fill"
                          aria-hidden="true"
                        ></b-icon>
                    </b-button>
                    <b-button
                        v-if="(vueText.length - 1) == index  && !disabled"
                        class="qoshish-btn-text"
                        variant="primary"
                        type="number"
                        @click="add"
                    >
                        <b-icon icon="plus" font-scale="2" color="#fff"></b-icon
                    ></b-button>
                </div>
            </div>
        </div>
        <!-- {{ vueText }} -->
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import 'quill/dist/quill.snow.css'; 
export default {
    props: [
        "text",
        "indReg",
        "indexChild",
        "defaultHeigth",
        "textValue",
        "kundalik",
        "disabled",
        "id",
        "status",
        "table_type"
    ],
    components: {
        // ckeditor: CKEditor.component
    },
    data(){
        return {
            editor: ClassicEditor,
            editorData: "<p>Content of the editor.</p>",
            editorConfig: {
                // The configuration of the editor.
            },
            vueText: [],
            textHeigth: "height: 1300px;",
            selectedWords: '',
            textChangeValue: {
                index: null,
                key: null,
            },
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"],
                [{ font: [] }],
                // [{ size: ["small", false, "large", "huge"] }],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                // ["blockquote", "code-block"],
                // [{ script: "sub" }, { script: "super" }],
                // [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }, { background: [] }],
                // ["link", "image", "video", "formula"],
                // [{ direction: "rtl" }],
                // ["clean"]
            ]
        }
    },
    mounted(){
        if(this.text != undefined){
            if(this.text[0] == '<' || this.text.length == 0) {
                let data = [
                    { key: 'value', value: this.text }
                ]
                let x= JSON.stringify(data)
                this.$emit('vueEditorText', x, this.indReg, this.indexChild, this.textValue)
                this.vueText = data
            } else {
                this.vueText = JSON.parse(this.text.toString())
            }
        }
    },
    watch:{
        text(newVal, old){
            // let data = newVal.toString()
            // if(data.lenght == 0){
            //     let x = [
            //         {key: "value", value: ""}
            //     ]
            //     this.vueText = x
            // } else {
                if(newVal != undefined){
                    this.vueText = JSON.parse(newVal)
                } else {
                    
                }
            // }
            // this.selectedWords = this.findSelectedWords(newVal);
        }
    },
    methods:{
        ShifokorText(item, index) {
            let val = JSON.stringify(this.vueText)
            this.$emit('vueEditorText', val, this.indReg, this.indexChild, this.textValue)

            // let maxHeight = 0
            // if(index){
            //     maxHeight = 1300
            // } else {
            //     maxHeight = 1020;
            // }

            // const editorContainer = this.$el.querySelector('#text' + index);

            // if (editorContainer.scrollHeight > maxHeight) {
                
            // } else {
                
            // }
        },
        copyText(){
            var selectedText = window.getSelection().toString();
        },
        changeEdiror(item, ind){
            let selectedText = window.getSelection().toString();
            if(selectedText != '' && selectedText != null){
                this.selectedWords = selectedText
                // this.selectedWords = ''
            }
            this.$emit('textChangeValueIndex', item.key, ind, this.textValue)
            this.textChangeValue = {
                index: ind,
                key: item.key
            }
            
            // const editor = this.$refs['vueTextEditor' + index];

            // const selection = window.getSelection();

            // if (selection) {
                // const range = selection.getRangeAt(0);
                // const offset = range.startOffset;
                // const container = range.startContainer;
                
            // }
        },
        ArrowClick(){
            if(this.selectedWords && !this.$store.state.kasTar){
                this.$store.state.ArrowData = ''
                const removedText = this.selectedWords.replace(/(\r\n|\n|\r)/gm, ' ');

                this.$store.state.ArrowData = removedText
                // this.$store.state.ArrowData = `${'<p>' + this.selectedWords + '</p>'}`

                this.$bvToast.toast(this.$t("Малумотлар қўшилди"), {
                    title: this.$t("Огоҳлантириш"),
                    autoHideDelay: 2000,
                    appendToast: true,
                    variant: "success"
                });
                this.selectedWords = ''
                // this.$emit('ArrowData', this.selectedWords)
            } else {
                // if(this.selectedWords){
                //     console.log(this.selectedWords)
                // }
                // this.$store.state.textKasallikTar = this.text
                this.$emit("kasTarText", this.text, this.id, this.status, this.table_type)
                console.log(this.table_type, "gtgtgtgttgt")
                this.$bvToast.toast(this.$t("Малумотлар қўшилди"), {
                    title: this.$t("Огоҳлантириш"),
                    autoHideDelay: 2000,
                    appendToast: true,
                    variant: "success"
                });
                // console.log(this.text)
            }
        },
        add(){
            let val = new Date().valueOf().toString()
            this.vueText.push({
                key: val,
                [`${val}`]: ''
            })
            let valText = JSON.stringify(this.vueText)
            this.$emit('vueEditorText', valText, this.indReg, this.indexChild, this.textValue)
        },
        deleteText(index){
            this.vueText.splice(index, 1)
            let valText = JSON.stringify(this.vueText)
            this.$emit('vueEditorText', valText, this.indReg, this.indexChild, this.textValue)
        },
        textPechat(item){
            let data = [item]
            let x = {
                statsionar_text: JSON.stringify(data)
            }
            localStorage.setItem("StatsionarPechat", JSON.stringify(x));
            // this.$router.push("/user");
            const rout = this.$router.resolve({
                path: "/user-statsionar"
            });
            window.open(rout.href, "_blank");
        }
    }
}
</script>
<style lang="scss">
.text-control{
    width: 100%;
    margin-bottom: 20px;
    /* border: 1px solid red; */
    overflow-y: auto;
    min-height: 1100px;
}
.text-control .ql-editor {
    // text-transform: uppercase;
    font-family: 'Times New Roman', Times, serif !important;
    // color: #000;
    p{
        font-size: 20pt;
        line-height: 20pt;
    }
    strong {
        font-weight: 700 !important;
    }
    u{
      font-weight: 700 !important;
    }
    h1, h2, h3, h4, h5, h6 {
        // text-transform: uppercase;
        font-family: 'Times New Roman', Times, serif !important;
        color: #000;
        // font-size: 20px;
        font-weight: 400;
    }
    h1{
        font-size: 26pt !important;
        line-height: 26pt;
    }
    h2{
        font-size: 24pt !important;
        line-height: 24pt;
    }
    h3{
        font-size: 14pt !important;
        line-height: 14pt;
    }
    h4{
        font-size: 12pt !important;
        line-height: 12pt;
    }
    h5{
        font-size: 10pt !important;
        line-height: 10pt;
    }
    h6{
        font-size: 8pt !important;
        line-height: 8pt;
        // color: red;
        text-transform:  none !important;
    }
}

.ck.ck-editor{
    width: 960px;
}
.ck-editor__editable_inline{
    height: 1000px !important;
}
.ck-editor__editable {
    p{
        font-size: 20pt;
        line-height: 26px;
        margin: 0px !important;
        padding: 0px !important;
        font-family: 'Times New Roman', Times, serif;
    }
    strong {
        font-weight: 700 !important;
    }
    u{
      font-weight: 700 !important;
    }
    h1, h2, h3, h4, h5, h6 {
        // text-transform: uppercase;
        font-family: 'Times New Roman', Times, serif !important;
        // color: #000;
        // font-size: 20px;
        font-weight: 400;
    }
    h1{
        font-size: 26pt !important;
        line-height: 32px;
    }
    h2{
        font-size: 24pt !important;
        line-height: 30px;
    }
    h3{
        font-size: 22pt !important;
        line-height: 28px;
    }
    h4{
        font-size: 18pt !important;
        line-height: 24px;
    }
    h5{
        font-size: 16pt !important;
        line-height: 22px;
    }
    h6{
        font-size: 14pt !important;
        line-height: 20px;
    }
}
.ck-content .table table td{
    padding: 0px 5px !important;
    text-align: center;
    font-size: 11pt;
}
.ck-content .table table th{
    padding: 0px 5px !important;
    text-align: center !important;
    font-size: 11pt;
}

.vueTextEditor{
    width: 950px;
}
.qoshish-btn-text {
  /* left: 990px; */
  background: #195fb0;
  position: absolute;
  right: -54px;
  bottom: -45px;
  /* margin-top: 5px; */
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #195fb0;
  box-shadow: 5px 8px 16px rgba(25, 95, 176, 0.5);
}
.btnArrowIndex{
    background: #4e9df7;
    height: calc(100% - 100px);
    position: absolute;
    right: -54px;
    top: 50px;
}
.btnArrow{
    background: #4e9df7;
    height: calc(100% - 200px);
    position: absolute;
    right: -54px;
    top: 50px;
}
.textPechat{
    background: #195fb0;
    position: absolute;
    bottom: 100px;
    right: -54px;
    width: 40px;
    height: 40px;
    display: flex;
    border: 1px solid #195fb0;
    box-shadow: 5px 8px 16px rgba(25, 95, 176, 0.5);
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}
.textPechatI{
    background: #195fb0;
    position: absolute;
    bottom: 0px;
    right: -54px;
    width: 40px;
    height: 40px;
    display: flex;
    border: 1px solid #195fb0;
    box-shadow: 5px 8px 16px rgba(25, 95, 176, 0.5);
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}
.trash-text {
  background: #facccc;
  position: absolute;
  bottom: 50px;
  right: -54px;
  width: 40px;
  height: 40px;
  display: flex;
  border: 1px solid #ff7979;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>